module.exports = "/_next/static/images/tanisha-8d732a018db29ace82042d7aebe2ad8a.png";